import * as React from 'react';
import { createElement } from 'react';
import { Form, Button } from '@alifd/next';
import ProCard from '@/components/layout/pro-card';
const CbayelComplexForm = (props, ref) => {
    const { children, status, operations = [], color, field, colon, changingField, service, ...otherProps } = props;
    const isPreview = status === 'readonly';
    return (createElement(Form, { ...otherProps, ref: ref, field: field, colon: colon },
        children
            ? formatChildForm(children, {
                color,
                isPreview,
                field,
                colon,
                changingField,
            })
            : null,
        isPreview ? null : (createElement("div", { style: { textAlign: 'center' } },
            createElement(Button.Group, null, operations.map(({ id, content, type, onClick }) => {
                return (createElement(Button, { key: id, onClick: onClick, type: type }, content));
            }))))));
};
const CbayelComplexFormRef = React.forwardRef(CbayelComplexForm);
export default CbayelComplexFormRef;
const formatChildForm = (children, globalProps) => {
    const { color, isPreview, field, colon, changingField } = globalProps;
    return React.Children.map(children, (child) => {
        const { props } = child;
        const { cardProps = {} } = props;
        const { primaryKey, ...restProps } = cardProps;
        return (createElement(ProCard, { key: primaryKey, ...restProps, color: color, field: field }, React.cloneElement(child, {
            isPreview,
            field,
            colon,
            changingField,
        })));
    });
};
